























import {
  computed,
  defineComponent,
  ref,
  vue3Model,
  watch
} from '~/utils/nuxt3-migration'
import CFormGroup from '~/components/shared/configurable/form/CFormGroup.vue'
import CTreeSelect from '~/components/shared/configurable/form/select/tree/CTreeSelect.vue'
import { debounce } from '~/utils/function'

export default defineComponent({
  model: vue3Model,
  components: {
    CFormGroup,
    CTreeSelect
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const facet = ref(props.modelValue)
    const selectedValues = ref(facet.value?.values?.selected || [])
    const localSelectedValues = ref(facet.value?.values?.selected || [])
    const isUserInteracting = ref(false)

    watch(
      () => props.modelValue,
      newValue => {
        facet.value = {
          ...facet.value,
          ...newValue
        }
        selectedValues.value = facet.value?.values?.selected || []

        // Only update localSelectedValues if user is not currently interacting
        if (!isUserInteracting.value) {
          localSelectedValues.value = facet.value?.values?.selected || []
        }
      }
    )

    const options = computed(() => {
      if (!facet.value.searchables) {
        return []
      }

      if (facet.value.showSelectedCategoryChildrenOnly) {
        const selectedSearchable = facet.value.searchables.find(
          searchable => searchable.s
        )

        return selectedSearchable.k
      }

      return facet.value.searchables
    })

    const emitModelUpdate = debounce((newValues: string[]) => {
      isUserInteracting.value = false
      emit('update:modelValue', {
        name: facet.value?.urlargNames?.[0],
        value: newValues.length ? newValues : null
      })
    })

    const handleChange = (newValues: string[]) => {
      isUserInteracting.value = true
      localSelectedValues.value = newValues
      emitModelUpdate(newValues)
    }

    return {
      facet,
      selectedValues,
      localSelectedValues,
      options,
      handleChange
    }
  }
})
